import "../pages/CheckIn.css";
import { React, useState, useEffect, useRef, Component ,useImperativeHandle, forwardRef} from "react";
import DatePicker, { DateObject } from 'react-multi-date-picker';
import Box from '@mui/material/Box';
import { apiMain } from "../../App";
import { Messages } from "../data/Messages";
import { useSnackbar } from "notistack";
import { useParams } from 'react-router-dom';
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import TextField from "@mui/material/TextField";
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import ico2 from "../images/ExitIcon.png"
import rest1  from '../images/Rest1.svg'
import { Loading } from "../Loading";
import Repair_Data from "./Repair_Data";
import Select, { SelectChangeEvent } from '@mui/material/Select';
const Repair=forwardRef((props,ref)=>{
  
  useImperativeHandle(ref, () => ({
    add: sendAdd,
    edit: sendUpdate,
    del: sendDelete,
    new: cleardata,
  }));
  const [value, setValue] = useState('1');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [loading, setLoading] = useState(false);
  const [User, setUser] = useState([]);
  const [UserId,setUserId]=useState([]);
  const [Dayind,setDayind]=useState([]);
  const [Addflag,setAddflag]=useState(true);
  const [Addflagmanage,setAddflagmanage]=useState(false);
  const [EditFlag,setEditFlag]=useState(false);
  const [DelFlag,setDelFlag]=useState(false);
  const [NewFlag,setNewFlag]=useState(true);
  const [Pass_No, setPass_No] = useState(0);
  const [Pass_FName, setPass_FName] = useState("");
  const [Pass_LName, setPass_LName] = useState("");
  const [Mont,setMont]=useState([]);
  const InputRef = useRef(null)
  const [U_id, setU_id] = useState(0);
  const [updateCount, setUpdateCount] = useState(0);
   useEffect(() => {
  //        if (props.permission.length>0)
  //        {
     //      console.log(props)
           setAddflag(props.permission[10].Per_Add)
          //  setEditFlag(props.permission[10].Per_Edit)
          //  setDelFlag(props.permission[10].Per_Del)
           setAddflagmanage(props.permission[12].Per_Add)
          //  console.log(props.permission)
  //        }
     getUser();
      getData();
      getShowData();
   
 }, [])
//  useEffect(() => {
         
//   getData();
// }, [updateCount])
 
const getShowData = async () => {
  let uparams = new URLSearchParams();
  uparams.append("Reserv_Id", localStorage.getItem('Reserv_Id'));

  let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectreservid?${uparams}`, true);

  // let res = await GetDataPromise(`${apiMain}/api/v1/reservation`, force);
  let parsed = JSON.parse(res);

  if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
    let newData = parsed.data;
  //   setDataView(newData)
   setPass_No(newData[0].Pass_No)
     setPass_FName(newData[0].Pass_FName)
     setPass_LName(newData[0].Pass_LName)
  }
 // setLoading(false)

}
const changeU_id = (event) => {
  setU_id(event.target.value);
};
const getUser = async () => {
  setLoading(true)

  let res = await GetDataPromise(`${apiMain}/api/v1/users`, true);
  let parsed = JSON.parse(res);
  if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
    let newData = parsed.data;
    setUserId(newData)
  }
  setLoading(false)
}
  const getData = async ( ) => {

    let uparams = new URLSearchParams();
  //  uparams.append("U_id", localStorage.getItem('U_id'));

      let res = await GetDataPromise(`${apiMain}/api/v1/repair/selectUserId`, true);

    let parsed = JSON.parse(res);
    if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
        let newData = parsed.data;
        console.log(newData)
        setData(newData)
       
    }
 
}

  
  const params = useParams()
   const [data, setData] = useState();

  const { enqueueSnackbar } = useSnackbar();
  const [dialogLoading, setDialogLoading] = useState(false);
  const [dialogError, setDialogError] = useState({});
  //const [Reserv_Id, setReserv_Id] = useState(0);
 	const [Id, setId] = useState(0);
    const [Repairs_Date, setRepairs_Date] = useState("");
    const [Repairs_Desc, setRepairs_Desc] = useState("");
    const [Repairs_Refre_Date, setRepairs_Refre_Date] = useState(""); 
    const [Repairs_Desc2, setRepairs_Desc2] = useState("");
    const [Repairs_Result, setRepairs_Result] = useState("");
    const [Repairs_Result_Date, setRepairs_Result_Date] = useState("");
    
   // const [Rtype_Id, setRtype_Id  ]=useState(0);
   
    const [PresentTypeData, setPresentTypeData] = useState([]);


  //   function handleCloseresturant() {
  //    // props.ChangeXpage(0)
  //  }

const changeRegistration_Date =(event)  =>{
  setRepairs_Date(event.year + '-' + event.month + '-' + event.day);
 // console.log(event.year + '-' + event.month + '-' + event.day)
  }
  const changeRefrence_Date =(event)  =>{
    setRepairs_Refre_Date(event.year + '-' + event.month + '-' + event.day);
 //   console.log(event.year + '-' + event.month + '-' + event.day)
    }
  //   const changesetId = (event) => {
  //     setId(event.target.value);
  //  };
    //  const handleSubmit = (e) => {
    //     e.preventDefault();
   
    //     // Add your form submission logic here
    // };
    const changeResult_Date =(event)  =>{
      setRepairs_Result_Date(event.year + '-' + event.month + '-' + event.day);
 
      }

    const sendDelete = async (e) => {
      let formdata = new FormData();

    // let errors = {};
      formdata.append("id", Id);

      let response;
      if(Id > 0){
          if( Repairs_Desc2 !=null)
          {
            alert('You cannot delete this data.')
            return;
          }
          else
        {
          response = await PostDataPromise(apiMain + "/api/v1/repair/delete", formdata);
}
         //  let parsed = JSON.parse(response);

           
       } 
         
      setDialogLoading(false);
      let parsed = JSON.parse(response);
      if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
          // okay
          enqueueSnackbar(Messages.success, { variant: 'success' });

          // props.save()
      } else {
          if(parsed.data && typeof parsed.data.message === "string"){
              enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
          }
          setDialogError((parsed.data) ? parsed.data.message : {})
      }
   //   setUpdateCount((prev) => prev + 1)
      getData();
      cleardata()
      alert('Data deleted successfully.')
    }
const cleardata=()=>{

  setId(0);
  setRepairs_Date('');
  setRepairs_Desc('');
  setRepairs_Desc2('');
  setRepairs_Result('');
  setRepairs_Refre_Date('');
  setU_id(0);
  setEditFlag(false);
  setDelFlag(false);
  setAddflag(true);
}
    const sendUpdate = async (e) => {
      let formdata = new FormData();

  //    let errors = {};
     // setPass_Id(0);
     formdata.append("id", Id);
           formdata.append("Repairs_Date", Repairs_Date);
              formdata.append("Repairs_Desc", Repairs_Desc);  
      formdata.append("U_id",  localStorage.getItem('U_id'));
    //         formdata.append("Repairs_Refre_Date", Repairs_Refre_Date);
    //   formdata.append("U_Refer_Id", U_id);
    //   formdata.append("Repairs_Desc2", Repairs_Desc2);
    //  formdata.append("Repairs_Result", Repairs_Result);
      let response;
      console.log(Id)
      if(Id > 0){

           response = await PostDataPromise(apiMain + "/api/v1/repair/update", formdata);

        //   let parsed = JSON.parse(response);

           
       }
      setDialogLoading(false);
      let parsed = JSON.parse(response);
      console.log(response)
      if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
          // okay
          enqueueSnackbar(Messages.success, { variant: 'success' });

          // props.save()
      } else {
          if(parsed.data && typeof parsed.data.message === "string"){
              enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
          }
          setDialogError((parsed.data) ? parsed.data.message : {})
      }
      // setUpdateCount((prev) => prev + 1)
      getData();
      cleardata();
      alert('Data saved successfully.')
  }
  const sendUpdatemanage = async (e) => {
    let formdata = new FormData();

//    let errors = {};
   // setPass_Id(0);
   formdata.append("id", Id);
     formdata.append("Repairs_Refre_Date", Repairs_Refre_Date);
    formdata.append("U_Refer_Id", U_id);
    formdata.append("Repairs_Desc2", Repairs_Desc2);
  //  formdata.append("Repairs_Result", Repairs_Result);
    let response;
    if(Id > 0){

         response = await PostDataPromise(apiMain + "/api/v1/repair/updatemanage", formdata);

      //   let parsed = JSON.parse(response);

         
     }
    setDialogLoading(false);
    let parsed = JSON.parse(response);
    console.log(response)
    if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
        // okay
        enqueueSnackbar(Messages.success, { variant: 'success' });

        // props.save()
    } else {
        if(parsed.data && typeof parsed.data.message === "string"){
            enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
        }
        setDialogError((parsed.data) ? parsed.data.message : {})
    }
    // setUpdateCount((prev) => prev + 1)
    getData();
    cleardata();
    alert('Data saved successfully.')
}
const sendUpdateresult = async (e) => {
  let formdata = new FormData();

//    let errors = {};
 // setPass_Id(0);
 formdata.append("id", Id);
   formdata.append("Repairs_Result_Date", Repairs_Result_Date);

 formdata.append("Repairs_Result", Repairs_Result);
  let response;
  if(Id > 0){

       response = await PostDataPromise(apiMain + "/api/v1/repair/updateresult", formdata);

    //   let parsed = JSON.parse(response);

       
   }
  setDialogLoading(false);
  let parsed = JSON.parse(response);
  console.log(response)
  if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
      // okay
      enqueueSnackbar(Messages.success, { variant: 'success' });

      // props.save()
  } else {
      if(parsed.data && typeof parsed.data.message === "string"){
          enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
      }
      setDialogError((parsed.data) ? parsed.data.message : {})
  }
  // setUpdateCount((prev) => prev + 1)
  getData();
  cleardata();
  alert('Data saved successfully.')
}
  const sendAdd = async (e) => {
    let formdata = new FormData();

//    let errors = {};
   // setPass_Id(0);
         formdata.append("Repairs_Date", Repairs_Date);
            formdata.append("Repairs_Desc", Repairs_Desc);  
    formdata.append("U_id",  localStorage.getItem('U_id'));
  //         formdata.append("Repairs_Refre_Date", Repairs_Refre_Date);
  //   formdata.append("U_Refer_Id", U_id);
  //   formdata.append("Repairs_Desc2", Repairs_Desc2);
  //  formdata.append("Repairs_Result", Repairs_Result);
    let response;
    if(Id == 0){
        // new
         response = await PostDataPromise(apiMain + "/api/v1/repair/insert", formdata);
     //let parsed = JSON.parse(response);
   }
    setDialogLoading(false);
    let parsed = JSON.parse(response);
    console.log(parsed)
    if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
        // okay
        enqueueSnackbar(Messages.success, { variant: 'success' });

        // props.save()
    } else {
        if(parsed.data && typeof parsed.data.message === "string"){
            enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
        }
        setDialogError((parsed.data) ? parsed.data.message : {})
    }
    // setUpdateCount((prev) => prev + 1)
    getData();
    cleardata();
    alert('Data saved successfully.')
}
  //  const [count, setCount] = useState(0); // useState returns a pair. 'count' is the current state. 'setCount' is a function we can use to update the state.
  function allitemupdate(id,Repairs_Date,Repairs_Desc,Repairs_Desc2,Repairs_Refre_Date,Repairs_Result,U_Refer_Id)
  {
 
   setId(id);
   setRepairs_Date(Repairs_Date);
   setRepairs_Desc(Repairs_Desc);
   setRepairs_Desc2(Repairs_Desc2);
   setRepairs_Refre_Date(Repairs_Refre_Date);
   setRepairs_Result(Repairs_Result);
   setU_id(U_Refer_Id);
  //  setEditFlag(true);
  //  setDelFlag(true);
   setAddflag(false);
   setEditFlag(props.permission[10].Per_Edit)
   setDelFlag(props.permission[10].Per_Del)
    InputRef.current.focus()
   

  }

if (loading)
{return
  <Loading small={true}/>}


    return (
        <>
             {/* <div className="CheckIn" style={{float:'left',textAlign:'left', width:'700px',marginTop:'0px',marginLeft:'0px'}}> */}
               <fieldset>
                <form action="#" method="get">
                {/* <div className="CheckIn"  style={{float:'left',textAlign:'left',width:'600px',marginLeft:'0px',height:'40px',marginTop:'10px'}}>

                      <Stack direction="row" spacing={1} style={{justifyContent:'center',alignItems:'center', paddingLeft:'30px',marginTop:'5px'}}>
                      <Chip label="New" onClick={cleardata} color="primary" disabled={!NewFlag} sx={{width:80 ,cursor:'pointer'}} />

                      <Chip label="Add" onClick={sendAdd} color="primary" disabled={!Addflag} sx={{width:80 ,cursor:'pointer'}} />
                      <Chip label="Edit" onClick={sendUpdate} color="primary" disabled={!EditFlag} sx={{width:80 ,cursor:'pointer'}} />

                      <Chip label="Delete" onClick={sendDelete} color="error" disabled={!DelFlag} sx={{width:80 , cursor:'pointer'}} />
                          
                      </Stack>

   </div> */}
                <div className="CheckIn"  style={{float:'left',textAlign:'left',width:'600px',marginLeft:'0px',height:'120px',marginTop:'0px'}}>
                   <label style={{fontSize:'12px',marginLeft:'0px'}} for="checkoutdate">Registration date*</label>
                     <DatePicker
                  style={{height:"35px", marginLeft:"20px",width:'100px'}}
                        // inputClass={"rmdp-input "+ classes + " " + className}
                        className={((window.innerWidth < 1550) ? "rmdp-mobile " : "")}
                        name="Checkoutdate"
                        required={true}
                        disabled={false}
                         calendarPosition="bottom"
                       //  format='YYYY-MM-dd'
                        // minDate={minDate}
                      //  calendar={gregorian} 
                        locale={"en"} 
                     value={Repairs_Date} 
                  
                   onChange={changeRegistration_Date}
                        // range={range}
                        // rangeHover={range}
                    />
              
                  
                        <div style={{marginLeft:'10px',marginTop:'10px'}}> 
                       <label    for="  Description" style={{marginLeft:'20px',fontSize:'12px'}}>Description*</label>
                       {/* </div> */}
                       <TextField
                              multiline
                              rows={2} // کمترین ارتفاع multiline
                              value={Repairs_Desc}
                              onChange={(e) => setRepairs_Desc(e.target.value)}
                              placeholder=" Enter Description"
                              variant="outlined"
                              ref={InputRef}
                              sx={{
                                width: 480,
                                marginTop: 0,
                                marginLeft: 1,
                                backgroundColor:"rgb(217, 217, 198)",
                                "& .MuiInputBase-inputMultiline": {
                                  padding: "4px 8px", // padding دلخواه خودت
                                  lineHeight: 1.2,
                                  resize: "none",     // اگر نمیخوای کاربر تغییر اندازه بده
                                  minHeight: "auto",  // اجازه بده minHeight تابع محتوای rows باشه
                                },
                              }}
                            />

</div>
</div>
          <div className="CheckIn"  style={{float:'left',textAlign:'left',width:'600px',marginLeft:'0px',height:'120px',marginTop:'0px'}}>
                    <label   style={{marginTop:'10px',fontSize:'12px'}}  for="checkoutdate">Reference date*</label>
               
                     <DatePicker
                  style={{height:"35px", marginLeft:"30px"}}
                        // inputClass={"rmdp-input "+ classes + " " + className}
                        className={((window.innerWidth < 1550) ? "rmdp-mobile " : "")}
                        name="Checkoutdate"
                        required={true}
                       disabled={!Addflagmanage} 
                         calendarPosition="bottom"
                       //  format='YYYY-MM-dd'
                        // minDate={minDate}
                      //  calendar={gregorian} 
                        locale={"en"} 
                     value={Repairs_Refre_Date} 
                  
                   onChange={changeRefrence_Date}
                        // range={range}
                        // rangeHover={range}
                    />
                         <Chip label="Save" onClick={sendUpdatemanage} color="primary" disabled={!Addflagmanage} sx={{width:80 ,cursor:'pointer',marginLeft:'10px'}} />

                       <div style={{marginLeft:'10px',marginTop:'10px'}}> 
                       <label  for="Description" style={{marginLeft:'20px',fontSize:'12px'}}>Description* </label>
                         <TextField
                              multiline
                              rows={2} // کمترین ارتفاع multiline
                              value={Repairs_Desc2}
                              onChange={(e) => setRepairs_Desc2(e.target.value)}
                              placeholder=" Enter Reference Description"
                              variant="outlined"
                              ref={InputRef}
                              disabled={!Addflagmanage} 
                              sx={{
                                width: 480,
                                marginTop: 0,
                                marginLeft: 1,
                                backgroundColor:"rgb(217, 217, 198)",
                                "& .MuiInputBase-inputMultiline": {
                                  padding: "4px 8px", // padding دلخواه خودت
                                  lineHeight: 1.2,
                                  resize: "none",     // اگر نمیخوای کاربر تغییر اندازه بده
                                  minHeight: "auto",  // اجازه بده minHeight تابع محتوای rows باشه
                                },
                              }}
                            />
</div>
              </div>
              <div className="CheckIn"  style={{float:'left',textAlign:'left',width:'600px',marginLeft:'0px',height:'120px',marginTop:'0px'}}>

                <label  style={{marginTop:'10px',fontSize:'12px'}}  for="PassportNo">Result Date *</label>
                <DatePicker
                  style={{height:"35px", marginLeft:"30px"}}
                        // inputClass={"rmdp-input "+ classes + " " + className}
                        className={((window.innerWidth < 1550) ? "rmdp-mobile " : "")}
                        name="Checkoutdate"
                        required={true}
                        disabled={!Addflagmanage} 

                         calendarPosition="bottom"
                       //  format='YYYY-MM-dd'
                        // minDate={minDate}
                      //  calendar={gregorian} 
                        locale={"en"} 
                     value={Repairs_Result_Date} 
                  
                   onChange={changeResult_Date}
                        // range={range}
                        // rangeHover={range}
                    />
                     <Chip label="Save" onClick={sendUpdateresult} color="primary" disabled={!Addflagmanage} sx={{width:80 ,cursor:'pointer',marginLeft:'10px'}} />

           <div style={{marginLeft:'10px',marginTop:'10px'}}> 
                <label for="Pay"  style={{marginLeft:'20px',fontSize:'12px'}}>Result</label>
                 
                <TextField
                              multiline
                              rows={2} // کمترین ارتفاع multiline
                              value={Repairs_Result}
                              onChange={(e) => setRepairs_Result(e.target.value)}
                              placeholder=" Enter Result"
                              variant="outlined"
                              disabled={!Addflagmanage} 
                              sx={{
                                width: 480,
                                marginTop: 0,
                                marginLeft: 6,
                                backgroundColor:"rgb(217, 217, 198)",
                                "& .MuiInputBase-inputMultiline": {
                                  padding: "4px 8px", // padding دلخواه خودت
                                  lineHeight: 1.2,
                                  resize: "none",     // اگر نمیخوای کاربر تغییر اندازه بده
                                  minHeight: "auto",  // اجازه بده minHeight تابع محتوای rows باشه
                                },
                              }}
                            />

                  
</div>
           </div>

                    </form>
            </fieldset>
{/* </div> */}
 {/* <Box sx={{ display:'inline-block', width:'600px',height:'450px', marginLeft:'470px',marginTop:'-180px'}}> */}
      {/* <div className="CheckIn" style={{display:'inline-block', width:'300px',height:'570px', marginLeft:'650px',marginTop:'0px'}}>  
      <img onClick={() => handleCloseresturant()} src={ico2} alt={"/"} style={{ float:'right',width: '30px', height: '30px', cursor: 'pointer' }} />

               <img  src={rest1} alt={"/" } style={{paddingTop:'100px'}} /> 
 </div>   */}
   {/* </Box> */}
 
  <div className="CheckIn" style={{float:'left', width:'700px',height:'200px',marginTop:'0px',marginLeft:'0px'}}> 
 
     <Repair_Data allupdate={allitemupdate} Room_Number={params.id} data={data}  />
 
  </div>

                

        </>
  
        
    );

})
export default Repair;